export default "__VITE_ASSET__DPVfc9LL__"